






import Vue from "vue";
import { Component } from "vue-property-decorator";
import Game, { GameType } from "@/components/Game.vue";
import views from "@/views/Views";

@Component({
  components: {
    Game,
  },
})
export default class SimplePath extends Vue {
  type: GameType = GameType.SIMPLEPATH;
  title = views.find((el) => el.component === GameType.SIMPLEPATH).title;
  video = "normalto.mp4";
}
